import * as Types from '../../../../__generated__/graphql';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ISendContactFormEmailMutationVariables = Types.Exact<{
  contactDealerInput: Types.IContactDealerInput;
}>;


export type ISendContactFormEmailMutation = { __typename?: 'Mutation', sendContactFormEmail: { __typename?: 'SendEmailResponse', success: boolean, message: string } };


export const SendContactFormEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendContactFormEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactDealerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactDealerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendContactFormEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactDealerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactDealerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;
export type ISendContactFormEmailMutationFn = Apollo.MutationFunction<ISendContactFormEmailMutation, ISendContactFormEmailMutationVariables>;

/**
 * __useSendContactFormEmailMutation__
 *
 * To run a mutation, you first call `useSendContactFormEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactFormEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactFormEmailMutation, { data, loading, error }] = useSendContactFormEmailMutation({
 *   variables: {
 *      contactDealerInput: // value for 'contactDealerInput'
 *   },
 * });
 */
export function useSendContactFormEmailMutation(baseOptions?: Apollo.MutationHookOptions<ISendContactFormEmailMutation, ISendContactFormEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendContactFormEmailMutation, ISendContactFormEmailMutationVariables>(SendContactFormEmailDocument, options);
      }
export type SendContactFormEmailMutationHookResult = ReturnType<typeof useSendContactFormEmailMutation>;
export type SendContactFormEmailMutationResult = Apollo.MutationResult<ISendContactFormEmailMutation>;
export type SendContactFormEmailMutationOptions = Apollo.BaseMutationOptions<ISendContactFormEmailMutation, ISendContactFormEmailMutationVariables>;